import { INVALID_CHARACTERS } from '../constants/sitecodes';

const cleanSitecodeString = (sitecode: string = '', invalidCharacters: string[] = INVALID_CHARACTERS) => {
  const pattern = new RegExp(`^[${invalidCharacters.join('')}]+|[${invalidCharacters.join('')}]+$`, 'g');

  return sitecode.replace(pattern, '');
};

export default cleanSitecodeString;
